import moment from "moment";
import { useSelector } from "react-redux";
export function useAvailableOption() {
  const compareOption = useSelector((state) => state.dataTable.compareOption);
  const dateFilter = useSelector((state) => state.dataTable.dateFilter);

  let startDate1 = moment(dateFilter.startDate1);
  let endDate1 = moment(dateFilter.endDate1);
  let startDate2 = moment(dateFilter.startDate2);
  let endDate2 = moment(dateFilter.endDate2);
  if (compareOption === "year") {
    startDate1.subtract(1, "year");
    endDate1.subtract(1, "year");
    startDate2.subtract(1, "year");
    endDate2.subtract(1, "year");
  } else if (compareOption === "month") {
    startDate1.subtract(1, "month");
    endDate1.subtract(1, "month");
    startDate2.subtract(1, "month");
    endDate2.subtract(1, "month");
  }
  const dayDIff1 = Math.abs(startDate1.diff(endDate1, "days"));
  const dayDIff2 = Math.abs(startDate2.diff(endDate2, "days"));
  const availableOption = [];
  if (!endDate2.isValid() && !startDate2.isValid()) {
    availableOption.push(...["day", "month", "quarter", "year"]);
  }
  if (dayDIff1 === dayDIff2) {
    availableOption.push("day");
  }

  if (
    startDate1.month() === startDate2.month() &&
    endDate1.month() === endDate2.month() &&
    startDate1.year() === endDate1.year() &&
    endDate1.year() &&
    endDate2.year()
  ) {
    availableOption.push("month");
    availableOption.push("quarter");
  }

  availableOption.push("selected_period");
  return availableOption;
}
